export interface EdgeHintController {
  show(): void;
}

export function createEdgeHintController(): EdgeHintController {
  let edgeHintShown = false;
  let edgeHintTimer: ReturnType<typeof setTimeout> | null = null;

  return {
    show(): void {
      if (edgeHintShown) return;
      edgeHintShown = true;
      const hint = document.getElementById('edge-hint');
      if (!hint) return;

      hint.classList.add('visible');
      if (edgeHintTimer) clearTimeout(edgeHintTimer);
      edgeHintTimer = setTimeout(() => {
        hint.style.transition = 'opacity 1.5s';
        hint.classList.remove('visible');
      }, 3000);
    },
  };
}
